import React from "react";
import AppLayout from "../components/app-layoout";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { LayoutContainer } from "../components/app-layoout/container";
import StarIcon from "../components/icons/StarIcon.js";
import CounterBox from "../components/CounterBox.js";
import OurValues from "../components/About/OurValues.js";
import Achievements from "../components/About/Achievements.js";
import Experience from "../components/About/Experience.js";
import Team from "../components/About/Team.js";
import Clients from "../components/About/OurClients/Clients.js";
import Image from "../components/image/image.js";

const AboutUs = () => {
  return (
    <AppLayout>
      <Stack pt={{ xs: 11, md: 15 }}>
        <LayoutContainer>
          <Grid
            container
            flexDirection={{ xs: "column-reverse", md: "row" }}
            pb={5}
            spacing={{ xs: 34, sm: 71, md: 2 }}
          >
            <Grid
              item
              xs={12}
              md={7}
              lg={6}
              pr={{ xs: 0, md: "20px", lg: "60px" }}
            >
              <Box mb={2}>
                <StarIcon />
              </Box>
              <Box mb={{ xs: "30px", md: "30px", lg: "70px" }}>
                <Typography variant="h3" color="text.secondary" mb={2}>
                  Más de 25 años creciendo sueños nos avalan. Un conglomerado de
                  empresas desarrolladoras y constructoras certificadas para
                  entregar productos de la mas alta calidad
                </Typography>
                <Typography variant="subtitle1" color="text.primary">
                  En un riguroso proceso de selección y certificación, Plusval
                  Estate realiza un escrutinio para presentarte las mejores
                  opciones en el mercado, dentro de un marco jurídico regulado
                  que brinda solidez dentro de un Fideicomiso de Administración
                  Inmobiliario que le da soporte legal y respaldo a todos
                  nuestros procesos, haciendo que tu experiencia sea
                  absolutamente placentera.
                </Typography>
              </Box>
              <CounterBox />
            </Grid>
            <Grid item xs={12} md={5} lg={6}>
              <Image src="/assets/about/home.png" ratio="4/3" />
            </Grid>
          </Grid>
          <OurValues
            title="Cada desarrollo con prototipos, disponibilidad y simuladores de compra en USD, MXN y por supuesto token SOIL"
            description="Mas de 2 mil clientes satisfechos en EEUU, México, Canadá y algunos países de europa"
            isCard={false}
          />
          <Achievements
            title="PlusvalEstates en Números"
            description="NO HA SIDO FÁCIL, PERO HEMOS LOGRADO AVANCES IMPORTANTES, Y LO QUE VIENE ES MUCHO MEJOR"
            isCard={true}
          />
          {/* <Experience /> */}
          <Team />
          {/*  <Clients /> */}
        </LayoutContainer>
      </Stack>
    </AppLayout>
  );
};

export default AboutUs;
